@if(!isLoading()){
  <lib-dropdown
    data-test="highlight-selector"
    [options]="availableStrategies()"
    [model]="selectedStrategy()"
    (modelChange)="updateStrategy($event)"
    label="Highlight"
  />
}
